import LoadingComponent from "../../shared/ui/animations/loading.js";
import React, { useEffect, useState } from "react";
import executeRequest from "../../modules/request.js";
import { Chart } from "react-chartjs-2";
import pl from "date-fns/locale/pl";
import moment from "moment";
import { getChartOptions } from "../../../../merchant/panel/components/galleryOrderStats/getChartOptions.js";
import GreyInfo from "../../../../merchant/panel/scripts/shared/greyInfo/greyInfo.js";
export default function StatusIndex(props) {
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState();
    const [data, setData] = useState();
    useEffect(() => {
        executeRequest("/api/public/system/latency/50Percentile", "GET", {}).then((res) => {
            setIsLoading(false);
            if (res.status !== 200) {
                setError("Nie udało się pobrać informacji...");
                return;
            }
            setData({
                mainServerLatency: res.timeseries,
                contentLoaderLatency: res.contentLoader,
            });
        });
    }, []);
    return (React.createElement("div", { className: "status-page-container" },
        React.createElement("section", { className: "status-page-main-section" },
            React.createElement("h2", null, "Status systemu Fotohub"),
            isLoading ?
                React.createElement(React.Fragment, null,
                    React.createElement(LoadingComponent, { extraPadding: true }),
                    "Pobieranie informacji o dzia\u0142aniu systemu...")
                : error ?
                    React.createElement("p", null, error)
                    : React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "stats-chart-container section status-page-chart-container" },
                            React.createElement(Chart, { type: "line", options: {
                                    ...getChartOptions(`Serwer główny, ostatnie 2 dni`, {
                                        displayLegend: true,
                                    }),
                                    spanGaps: true,
                                    scales: {
                                        y: {
                                            suggestedMax: 400,
                                            ticks: {
                                                autoSkipPadding: 20,
                                            },
                                        },
                                        x: {
                                            position: "bottom",
                                            type: "time",
                                            bounds: "data",
                                            adapters: {
                                                date: {
                                                    locale: pl,
                                                },
                                            },
                                            ticks: {
                                                autoSkipPadding: 60,
                                            },
                                            time: {
                                                unit: "minute",
                                                round: "minute",
                                                tooltipFormat: "LLLL d HH:mm",
                                                stepSize: 15,
                                                displayFormats: {
                                                    minute: "d MMM HH:mm",
                                                },
                                                minUnit: "minute",
                                            },
                                        },
                                    },
                                }, data: {
                                    datasets: [
                                        {
                                            data: data === null || data === void 0 ? void 0 : data.mainServerLatency.map((d) => {
                                                var _a, _b, _c;
                                                return ({
                                                    x: moment(Number((_b = (_a = d === null || d === void 0 ? void 0 : d.interval) === null || _a === void 0 ? void 0 : _a.startTime) === null || _b === void 0 ? void 0 : _b.seconds) * 1000).toDate(),
                                                    y: (_c = d === null || d === void 0 ? void 0 : d.value) === null || _c === void 0 ? void 0 : _c.doubleValue,
                                                });
                                            }),
                                            borderColor: "#4b4bf3",
                                            label: "Czas odpowiedzi (ms)",
                                            fill: true,
                                        },
                                    ],
                                } })),
                        React.createElement("div", { className: "stats-char-container section status-page-chart-container" },
                            React.createElement(Chart, { type: "line", options: {
                                    ...getChartOptions(`Serwer wczytujący treści, ostatnie 2 dni`, { displayLegend: true }),
                                    scales: {
                                        y: {
                                            suggestedMax: 400,
                                            ticks: {
                                                autoSkipPadding: 20,
                                            },
                                        },
                                        x: {
                                            position: "bottom",
                                            type: "time",
                                            bounds: "data",
                                            adapters: {
                                                date: {
                                                    locale: pl,
                                                },
                                            },
                                            ticks: {
                                                autoSkipPadding: 60,
                                            },
                                            time: {
                                                unit: "minute",
                                                round: "minute",
                                                tooltipFormat: "LLLL d HH:mm",
                                                stepSize: 15,
                                                displayFormats: {
                                                    minute: "d MMM HH:mm",
                                                },
                                                minUnit: "minute",
                                            },
                                        },
                                    },
                                }, data: {
                                    datasets: [
                                        {
                                            data: data === null || data === void 0 ? void 0 : data.contentLoaderLatency.map((d) => {
                                                var _a, _b, _c, _d;
                                                return ({
                                                    x: moment(Number((_b = (_a = d === null || d === void 0 ? void 0 : d.interval) === null || _a === void 0 ? void 0 : _a.startTime) === null || _b === void 0 ? void 0 : _b.seconds) * 1000).toDate(),
                                                    y: ((_d = (_c = d === null || d === void 0 ? void 0 : d.value) === null || _c === void 0 ? void 0 : _c.doubleValue) !== null && _d !== void 0 ? _d : 0) / 1000000,
                                                });
                                            }),
                                            borderColor: "#4b4bf3",
                                            label: "Czas odpowiedzi (ms)",
                                            fill: true,
                                        },
                                    ],
                                } })),
                        React.createElement("br", null),
                        React.createElement("br", null),
                        React.createElement(GreyInfo, null, "Czasy odpowiedzi poni\u017Cej 1000ms s\u0105 uznawane za normalne i nie wi\u0105\u017C\u0105 si\u0119 z zauwa\u017Calnymi op\u00F3\u017Anieniami.")))));
}
